// extracted by mini-css-extract-plugin
module.exports = {"arrowLink":"ArrowLink_arrowLink__t7icc","arrow":"ArrowLink_arrow__90AIE"};